import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import { App } from './App';
import { installFaultReporter, reportPageCrash } from './lib/faultReporter';
import { installDocumentFailureBox } from './lib/mutationErrors';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

// The Error Log's ear in the browser (2026-10-02): page crashes, promises
// nobody caught, chunks that would not load - and the queue of faults held
// while offline or before sign-in. See lib/faultReporter.
installFaultReporter();
installDocumentFailureBox();

ReactDOM.createRoot(rootEl, {
  // A crash while drawing a screen. There is no error boundary, so React
  // unmounts the tree and the person is left with an empty page; this is the
  // only place that crash is ever seen. React's own console line is kept.
  onUncaughtError: (error, info) => {
    console.error(error, info.componentStack);
    reportPageCrash(error, 'PAGE_CRASH');
  },
}).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
